module.exports = __webpack_public_path__ + "img/3.d7126c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/student-enquiry-form/3.png
// module id = 707
// module chunks = 1